/**
 * Chip component - displays a small labeled tag with optional tone
 */
import React from "react";

export type ChipTone = "ok" | "warn" | "bad" | "muted";

type ChipProps = {
  text: string;
  tone?: ChipTone;
};

const toneStyles: Record<ChipTone, React.CSSProperties> = {
  ok: { background: "var(--color-success-ghost)", color: "var(--color-success)", border: "1px solid color-mix(in srgb, var(--color-success) 40%, transparent)" },
  warn: { background: "var(--color-warning-ghost)", color: "var(--color-warning)", border: "1px solid color-mix(in srgb, var(--color-warning) 40%, transparent)" },
  bad: { background: "var(--color-danger-ghost)", color: "var(--color-danger)", border: "1px solid var(--color-danger-border)" },
  muted: { background: "var(--color-accent-ghost)", color: "var(--color-accent)", border: "1px solid color-mix(in srgb, var(--color-accent) 25%, transparent)" },
};

export const Chip: React.FC<ChipProps> = ({ text, tone = "muted" }) => {
  return (
    <span
      style={{
        ...toneStyles[tone],
        fontSize: 12,
        padding: "2px 8px",
        borderRadius: 999,
        fontWeight: 800,
      }}
    >
      {text}
    </span>
  );
};

export default Chip;
